import { CommonFilterModel } from '@/api/resources/common/shared/models/common.models'
import { AppliedBillableConceptEntityType } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { GridUtils } from '@/shared/util/grid-utils'

export const getFilterModelByEntity = (filterModel: CommonFilterModel, entityType: AppliedBillableConceptEntityType, accountingUnitId: number, nodeId: number): CommonFilterModel => {
    filterModel['unit.id'] = GridUtils.getNumberFilterModel('equals', accountingUnitId)
    switch (entityType) {
    case AppliedBillableConceptEntityType.CASE:
        filterModel['caseStudy.id'] = GridUtils.getNumberFilterModel('equals', nodeId)
        return filterModel
    case AppliedBillableConceptEntityType.SAMPLE:
        filterModel['sample.id'] = GridUtils.getNumberFilterModel('equals', nodeId)
        return filterModel
    case AppliedBillableConceptEntityType.PORTION:
        filterModel['portion.id'] = GridUtils.getNumberFilterModel('equals', nodeId)
        return filterModel
    case AppliedBillableConceptEntityType.SUBPORTION:
        filterModel['subportion.id'] = GridUtils.getNumberFilterModel('equals', nodeId)
        return filterModel
    default:
        return filterModel
    }
}
